import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ContactView } from './../../contact/models/contactView';
import { EmployeeContactServices } from './employee-admin.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class EmployeeWithLoginListResolver {
    constructor(private backend: EmployeeContactServices, private http: HttpClient) {}
    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        const defaultFilter = {
            PageNumber: 1,
            PageSize: 1000, // Large page size to get all employees initially
            SortColumn: 'Name',
            SortDirection: 'ASC'
        };
        return forkJoin({
            employee: this.backend.getPagedAdminEmployeeList(defaultFilter),
            business: this.http.get<any[]>(environment.BASE_URL + '/businesses/names')
        });
    }
}

@Injectable()
export class BusinessNamesResolver {
    constructor(private http: HttpClient) {}
    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        return this.http.get<any[]>(environment.BASE_URL + '/businesses/names');
    }
}


